// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__3GwXq","normalH5":"Index_normalH5__3EBtF","animationFade":"Index_animationFade__2T9HM"};